<template lang="html">
    <div class="default-page-paddings">
        <div class="container container-medium">
            <Heading :title="$t('legislative_info')" :alignment="'text-left'"></Heading>
            <a href="#" @click.prevent="scrollToElement('rovinieta')">{{$t('legislative_info')}} {{ capitalize($tc('vignetteWord', 1)) }}</a> |
            <a href="#" @click.prevent="scrollToElement('peaj')">{{$t('legislative_info')}} {{ capitalize($tc('tollWord', 0)) }}</a>
            <div class="default-content reading" id="rovinieta">
                <p class="heading-medium">{{ capitalize($tc('vignetteWord', 1)) }}</p>
                <div v-if="locale == 'ro'">
                    <p>
                        Ordonanţa nr. 15 din 24 ianuarie 2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        LEGE nr. 221 din 17 noiembrie 2016 pentru modificarea şi completarea Ordonanţei Guvernului nr. 15/2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/lege-nr-221-din-17-noiembrie-2016.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        ORDIN nr. 1463 din 21 septembrie 2018 privind aprobarea Normelor metodologice pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        NORME METODOLOGICE din 21 septembrie 2018 pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/norme-metodologice-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formular cerere corectii erori materiale
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/cerere_corectie_rovinieta_16.11.2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formulare cerere schimbare numar inmatriculare
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/Formular_cerere_schimbare_numar.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formular cerere restituire tarif de utilizare
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/cerere_corectie_rovinieta_16.11.2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Cerere restituire tarif de utilizare a drumurilor nationale pentru radiere din circulatie
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/radiere.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Cerere pentru restituirea tarifului de utilizare aferent diferentei de categorie
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/diferenta_categorie.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Cerere restituire tarif de utilizare a drumurilor nationale pentru plata dubla
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/plata_dubla.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Cerere restituire tarif de utilizare a drumurilor nationale pentru plata dubla in cazul instrainarii
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/lege-nr-221-din-17-noiembrie-2016.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                </div>
                <div v-else>
                    <p>
                        Ordinance no. 15 of January 24, 2002 on the application of the use tariff and the toll on the Romanian national road network
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        LAW no. 221 of November 17, 2016 for the amendment and completion of the Government Ordinance no. 15/2002 on the application of the use tariff and the toll on the Romanian national road network
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/lege-nr-221-din-17-noiembrie-2016.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        ORDER no. 1463 of September 21, 2018 regarding the approval of the Methodological Norms for the application by the CNAIR of the use tariff and the toll
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        METHODOLOGICAL NORMS from September 21, 2018 for the application by CNAIR CNAIR of the use tariff and the toll
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/norme-metodologice-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Material error correction request form
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/cerere_corectie_rovinieta_16.11.2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Registration number change application forms
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/Formular_cerere_schimbare_numar.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Usage rate refund application form
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/cerere_corectie_rovinieta_16.11.2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Application for reimbursement of the tariff for the use of national roads for non-registration
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/radiere.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Request for refund of usage fee for category difference
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/diferenta_categorie.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Refund application for use of national roads for double payment
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/plata_dubla.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Application for refund of the use of national roads for double payment in case of selling
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/plata_dubla_instrainare.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Ordinance no. 41 from April 8, 2022
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordin-nr-365-din-6-aprilie-2022')">{{ $t('info_download_file') }}</a>
                    </p>
                </div>
            </div>
            <div class="default-content reading" id="peaj">
                <p class="heading-medium">{{ capitalize($tc('tollWord', 0)) }}</p>
                <div v-if="locale == 'ro'">
                    <p>
                        Ordonanţa nr. 15 din 24 ianuarie 2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        LEGE nr. 221 din 17 noiembrie 2016 pentru modificarea şi completarea Ordonanţei Guvernului nr. 15/2002 privind aplicarea tarifului de utilizare şi a tarifului de trecere pe reţeaua de drumuri naţionale din România
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/lege-nr-221-din-17-noiembrie-2016.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        ORDIN nr. 1463 din 21 septembrie 2018 privind aprobarea Normelor metodologice pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        NORME METODOLOGICE din 21 septembrie 2018 pentru aplicarea de către Compania Naţională de Administrare a Infrastructurii Rutiere - S.A. a tarifului de utilizare şi a tarifului de trecere
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/norme-metodologice-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formular cerere corectii erori materiale
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/cerere-corectie-peaj-16.11.2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formular cerere scutire - peaj Fetești
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/Cerere-de-acordare-a-scutirii-pentru-peaj-Fetesti_0.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formular cerere restituire peaj diferente categorie
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/diferenta-categorie-peaj.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formular cerere restituire peaj număr eronat
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/numar-eronat-peaj.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Formular cerere restituire peaj radiere circulație
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/radiere-peaj.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                </div>
                <div v-else>
                    <p>
                        Ordinance no. 15 of January 24, 2002 on the application of the use tariff and the toll on the Romanian national road network
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordonanta-nr-15-din-24-ianuarie-2002.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        LAW no. 221 of November 17, 2016 for the amendment and completion of the Government Ordinance no. 15/2002 on the application of the use tariff and the toll on the Romanian national road network
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/lege-nr-221-din-17-noiembrie-2016.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        ORDER no. 1463 of September 21, 2018 regarding the approval of the Methodological Norms for the application by the CNAIR of the use tariff and the toll
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/ordin-nr-1463-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        METHODOLOGICAL NORMS from September 21, 2018 for the application by CNAIR CNAIR of the use tariff and the toll
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/norme-metodologice-din-21-septembrie-2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Material error correction request form
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/cerere-corectie-peaj-16.11.2018.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Exemption request form - Fetești toll
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/Cerere-de-acordare-a-scutirii-pentru-peaj-Fetesti_0.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Toll refund request form for categories differences
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/diferenta-categorie-peaj.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Wrong number toll refund request form
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/numar-eronat-peaj.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                    <p>
                        Traffic erasure toll refund application form
                        <a href="#" @click.prevent="openUrl(url + 'pdfs/radiere-peaj.pdf')">{{ $t('info_download_file') }}</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'
import { mapState } from 'vuex'

export default {
    name: 'Info',
    components: {
        Heading
    },
    computed: {
        ...mapState('language', [
            'locale'
        ])
    },
    data() {
        return {
            url: 'https://e-rovinieta.ro/'
        }
    },
    methods: {
        scrollToElement(id) {
            window.scrollTo({
              top: (document.getElementById(id).getBoundingClientRect().top + window.scrollY) - 50,
              behavior: 'smooth'
            });
        }
    }
}

</script>

<style lang="scss" scoped>
    p {
        a {
            padding-top: 10px;
            display: block;
        }
    }
</style>
